import { jsx as a } from "../../_virtual/jsx-runtime.mjs";
import { useMemo as t, useCallback as f } from "react";
import N from "../../depend/rc-tooltip/es/Tooltip.mjs";
import c from "../../depend/classnames/index.mjs";
import { rcToolTipPlacementMap as B, defaultReoBallonProps as m } from "./const.mjs";
import "../../depend/rc-tooltip/assets/bootstrap.css.mjs";
import { reoBallonContent as S, reoBallonChildren as k, typeColor as T, overlayClass as L, overLayInnerStyle as O } from "./css/ReoBallon.mjs";
import "./css/index.mjs";
import { useTheme as b } from "../../hook/useTheme.mjs";
import { EThemeTemplate as D } from "../../common/type.mjs";
const I = (e) => {
  const o = t(
    () => B[e.placement ?? m.placement],
    [e.placement]
  ), i = t(
    () => e.trigger ?? m.trigger,
    [e.trigger]
  ), r = t(
    () => ({
      backgroundColor: e.contentBackgroundColor,
      ...e.contentStyle
    }),
    [e.contentBackgroundColor, e.contentStyle]
  ), n = t(
    () => e.type ?? m.type,
    [e.type]
  ), y = t(() => c(
    S[n],
    e.contentClassName
  ), [e.contentClassName, n]), C = t(() => /* @__PURE__ */ a(
    "div",
    {
      className: y,
      style: r,
      children: e.content
    }
  ), [y, r, e.content]), l = b({ theme: e.theme, template: D.BALLOON }), s = t(() => /* @__PURE__ */ a(
    "div",
    {
      className: c(
        l,
        k,
        e.className
      ),
      style: e.style,
      children: e.children
    }
  ), [e.children, e.className, e.style, l]), d = f((v) => {
    e.onOpenChange && e.onOpenChange(v);
  }, [e]), g = t(() => ({
    "--arrow-color": e.contentBackgroundColor ?? T[n].backgroundColor,
    ...e.overlayStyle
  }), [e.contentBackgroundColor, e.overlayStyle, n]), h = t(
    () => c(
      "reo-tooltip-content",
      l,
      L[o.direction],
      e.overlayClassName
    ),
    [o.direction, e.overlayClassName, l]
  ), u = t(() => ({
    ...O,
    ...e.overlayInnerStyle
  }), [e.overlayInnerStyle]);
  return /* @__PURE__ */ a(
    N,
    {
      mouseEnterDelay: e.mouseEnterDelay,
      mouseLeaveDelay: e.mouseLeaveDelay,
      onVisibleChange: d,
      overlayClassName: h,
      overlayInnerStyle: u,
      overlayStyle: g,
      trigger: i,
      placement: o.placement,
      overlay: C,
      children: s
    }
  );
};
I.displayName = "ReoBalloon";
export {
  I as default
};
//# sourceMappingURL=ReoBalloon.mjs.map
